import soundpillMark from '../../../assets/logo/soundpill-mark.svg';

type SoundPillMarkProps = {
  className?: string;
};

/** Draft SoundPillMark — 헤더 브랜드 마크 */
export function SoundPillMark({ className = '' }: SoundPillMarkProps) {
  return (
    <img
      src={soundpillMark}
      alt=""
      width={32}
      height="auto"
      className={`block w-[32px] h-auto shrink-0 select-none ${className}`}
      draggable={false}
      aria-hidden
    />
  );
}
